var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
export default function useTsoaApi(
// TSOA style API function
apiFunc, clearDataOnRequest = true, debounceDelay = 0) {
    const [data, setData] = useState(undefined);
    const [error, setError] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);
    // eslint-disable-next-line no-undef
    const [debounceCallbackId, setDebounceCallbackId] = useState(null);
    const [queuedArgs, setQueuedArgs] = useState(null);
    const internalRequest = (...args) => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        // clear out previous api results
        if (clearDataOnRequest) {
            setData(undefined);
        }
        setError(null);
        try {
            const result = yield apiFunc(...args);
            setData(result.data);
        }
        catch (err) {
            setError(err || 'Unknown Error');
        }
        finally {
            setLoading(false);
            setLoaded(true);
        }
    });
    const request = (...args) => __awaiter(this, void 0, void 0, function* () {
        if (debounceDelay) {
            if (debounceCallbackId) {
                clearTimeout(debounceCallbackId);
            }
            setDebounceCallbackId(setTimeout(() => {
                setQueuedArgs(args);
            }, debounceDelay));
            setLoading(true);
        }
        else {
            yield internalRequest(...args);
        }
    });
    useEffect(() => {
        if (queuedArgs) {
            void internalRequest(...queuedArgs);
            setQueuedArgs(null);
        }
    }, [queuedArgs]);
    return {
        data,
        error,
        loading,
        loaded,
        request,
    };
}
//# sourceMappingURL=useTsoaApi.js.map